import { url } from "./url"; // 🔁 Make sure this path is correct

export const fetchLegalPageContent = async (slug) => {
  try {
    const response = await fetch(
      `${url.apiUrl}public/page/${slug}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();

    if (data.success && data.item?.description) {
      return data.item.description;
    }

    return null;
  } catch (error) {
    console.error("Error fetching legal content:", error);
    return null;
  }
};
